module.exports = __webpack_public_path__ + "img/q31-3.cae61ec6.jpg";